import { Link } from '@remix-run/react'

export default function EnrollCTA() {
	return (
		<div className="mx-auto mt-6 max-w-2xl rounded-lg bg-orange-500 p-6 shadow-lg transition-transform duration-300 hover:scale-105">
			<div className="flex flex-col items-center justify-between md:flex-row">
				{/* Left Section: Text */}
				<div className="text-center md:text-left">
					<p className="text-xl font-semibold text-white">
						Don't Miss! Start Preparing Like a Topper!
					</p>
					<p className="text-sm font-semibold text-white">
						Join India's Best Free Mock Test Experience
					</p>
				</div>

				{/* Right Section: CTA Button */}
				<div className="mt-4 md:mt-0">
					<Link to="../enroll/mta-mock">
						<button className="rounded-full bg-white px-6 py-3 text-lg font-bold text-orange-500 shadow-md hover:bg-orange-100 hover:shadow-lg focus:ring-4 focus:ring-orange-300">
							Enroll for Free!
						</button>
					</Link>
				</div>
			</div>
		</div>
	)
}
